import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-up-left', 'ChevronsUpLeft', [["path",{"d":"M7 15v-8h8"}],["path",{"d":"M11 19v-8h8"}]]);